import { ReactComponent as DecoderSvg } from './icons/decoder.svg';
import { ReactComponent as LockShieldSvg } from './icons/lock-shield.svg';
import { ReactComponent as LoveItHandSvg } from './icons/love-it-hand.svg';
import { ReactComponent as SearchListSvg } from './icons/search-list.svg';
import { ReactComponent as WalletSvg } from './icons/wallet.svg';
import { ReactComponent as WifiFlashSvg } from './icons/wifi-flash.svg';

type Svg = React.FunctionComponent<React.SVGProps<SVGSVGElement> & {
  title?: string;
}>;

// TODO: move to Sanity, figure out a way to manage icons as well
export const SELLINGPOINTS_DATA: { icon: Svg, title: string, text: string }[] = [
  {
    icon: WalletSvg,
    title: 'Spar penger',
    text: 'Samler du TV og internett hos oss får du en kostnadseffektiv og oversiktlig løsning.'
  },
  {
    icon: DecoderSvg,
    title: 'Bruk utstyret du har',
    text: 'Bruk ditt eksisterende TV- og internett utstyr, eller bestill nytt fra oss.'
  },
  {
    icon: LoveItHandSvg,
    title: 'Vi bytter internett for deg...',
    text: '...og sikrer et smidig bytte slik at du ikke betaler dobbelt for internett.'
  },
  {
    icon: SearchListSvg,
    title: 'Fritt valg av TV-pakke',
    text: 'Vi “bundler” ikke TV og internett. Vi samler det beste slik at du kan velge fritt.'
  },
  {
    icon: LockShieldSvg,
    title: 'Trygg og stabil fiberlinje',
    text: 'Vi leverer på Telenors nettverk. Du får samme sikre og stabile nettverk som før.'
  },
  {
    icon: WifiFlashSvg,
    title: 'Betal for det du trenger',
    text: 'Ikke betal for hastighet du aldri bruker, derfor gjør vi det enkelt å velge riktig nett.'
  },
];


export const GET_STARTED_POINTS = [
  {title: 'Gjennomfør adressesøk', description: 'Sjekk om du kan få TV og internett på adressen din.'},
  {title: 'Velg TV-pakke og internetthastighet', description: 'Vi tilbyr tre ulike internetthastigheter som garantert passer ditt behov og TV-pakker med godt utvalg av underholdning.'},
  {title: 'Vi hjelper deg å bytte', description: 'NextGenTel sier opp internett-avtalen din og holder deg oppdatert om når ditt nye internett blir levert. Har du TV-pakke hos en annen leverandør, må du si opp denne selv.'},
]